import PropTypes from 'prop-types';
import { CLOTHING_PREFERENCES, GENDER_OPTIONS } from '../../../../../config/dataConfig/FJHeadshotGeneratorData';
import OptionCard from '../OptionCard';

import styles from './StepForm.module.less';
import FJLocalStore from '../../../../../store/FJLocalStore';
import FJConfig from '../../../../../config/FJConfig';
import { useMemo } from 'react';
import FJFileHandleUtil from '../../../../../util/FJFileHandleUtil';

const FJClothingPreferenceSelector = ({
    selectedClothingPreference,
    onClothingPreferenceChange,
    gender = GENDER_OPTIONS.MALE,
}) => {
    const currentClothingOptions = useMemo(() => {
        return CLOTHING_PREFERENCES.filter(clothing => clothing.gender === gender);
    }, [gender]);

    return (
        <div className={styles.step_form}>
            <h3 className={styles.step_title}>{FJLocalStore._('select-your-clothing-style')}</h3>
            <div className={styles.options_grid}>
                {currentClothingOptions.map(clothing => (
                    <OptionCard
                        key={clothing.key}
                        title={FJLocalStore._(clothing.key)}
                        imageUrl={FJFileHandleUtil.getImageUrlWithFormat(
                            `${FJConfig.headshotImagePath}${clothing.imageUrl}?v=${FJConfig.version}`,
                        )}
                        isSelected={selectedClothingPreference?.value === clothing.value}
                        onClick={() => onClothingPreferenceChange(clothing)}
                    />
                ))}
            </div>
        </div>
    );
};

FJClothingPreferenceSelector.propTypes = {
    selectedClothingPreference: PropTypes.object,
    onClothingPreferenceChange: PropTypes.func,
    gender: PropTypes.string,
};

export default FJClothingPreferenceSelector;
